import React from "react";
import PermissionsForm from "./PermissionsForm";
import { ShieldCheck } from "lucide-react";

export default function PermissionsModal({ onClose }) {
  return (
    <div
      className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4 md:p-8 overflow-y-auto"
      data-testid="permissions-modal"
    >
      <div className="brutal bg-white max-w-2xl w-full my-auto p-6 md:p-8 relative">
        <div className="flex items-start gap-4 mb-5">
          <div className="w-12 h-12 bg-brand-orange border-2 border-black rounded-xl flex items-center justify-center shadow-brutal flex-shrink-0">
            <ShieldCheck className="w-6 h-6 text-white" strokeWidth={2.4} />
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-widest font-bold text-neutral-600">First things first</div>
            <h2 className="font-display font-black text-3xl sm:text-4xl leading-[1.02] tracking-tight">
              Your privacy preferences
            </h2>
            <p className="text-sm text-neutral-700 mt-2">
              Decide what we can do with your name and wins before you dive in. You can change these any time from Settings.
            </p>
          </div>
        </div>
        <PermissionsForm onSaved={onClose} submitLabel="Save & get started" />
      </div>
    </div>
  );
}
